import { style } from "@vanilla-extract/css";
import { popoverMenuContainer } from "plos/src/components/PopoverSelects/popover.css";
import { cellStyles } from "plos/src/components/Table/tables.css";
import { breakpoints, vars } from "plos/src/styles";
import filterPopoverStyles from "../FilterPopovers/filterPopover.module.css";

export const helpContainer = style({
  display: "flex",
  flexDirection: "column",
});

export const helpItem = style({
  selectors: {
    "&:not(:last-child)": {
      borderBottom: vars.borders.outlineVariant,
    },
  },
  "@media": {
    // On mobile the jump menu is sticky at the top of the viewport, so offset
    // fragment navigation by the sticky bar height (chip 32px + vertical
    // padding of vars.space.m top/bottom) plus a small buffer to keep the
    // selected section heading visible below the menu.
    [`screen and (max-width:${breakpoints[4]})`]: {
      scrollMarginTop: `calc(32px + ${vars.space.m} * 2 + ${vars.space.s})`,
    },
  },
});

export const contactTextArea = style({
  margin: 0,
  border: vars.borders.outline,
  borderRadius: vars.radii.xs,
  backgroundColor: vars.colors.surface,
  padding: vars.space.m,
  width: "100%",
  maxWidth: "100%",
  height: "auto",
  lineHeight: "1",
  color: vars.colors.primary,
});

export const termsContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.l,
});

export const helpSubheading = style({
  marginBottom: vars.space.xs,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.l,
  fontWeight: 400,
});

export const helpCell = style([
  cellStyles,
  {
    textWrap: "wrap",
  },
]);

export const contactButtons = style({
  display: "flex",
  gap: vars.space.s,
});

export const helpMobileMenu = style({
  position: "sticky",
  zIndex: vars.zIndex.table.stickyCol,
  top: 0,
  display: "flex",
  alignItems: "center",
  gap: vars.space.m,
  backgroundColor: vars.colors.bgColor,
  padding: `${vars.space.m} 0`,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      display: "none",
    },
  },
});

export const helpMenu = style({
  display: "none",

  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      display: "block",
    },
  },
});

export const stickyMenu = style({
  position: "sticky",
  top: vars.space.xl,
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
  maxHeight: `calc(100vh - ${vars.space.xl})`,
  overflowY: "auto",
});

export const helpMobileMenuContainer = style([
  popoverMenuContainer,
  {
    display: "flex",
    flexDirection: "column",
    backgroundColor: vars.colors.surface,
  },
]);

export const helpMobileMenuLink = style([
  filterPopoverStyles.popoverListItem,
  { textDecoration: "none", color: vars.colors.primary },
]);

export const helpMenuList = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const helpMenuListItem = style({
  selectors: {
    "&:not(:last-child)": {
      borderBottom: vars.borders.outlineVariant,
      paddingBottom: vars.space.xs,
    },
  },
});

export const helpMenuButtonLink = style({
  justifyContent: "flex-start",
});

export const helpMenuButtonLinkActive = style({
  backgroundColor: vars.colors.onSurfaceOpacityLow,
  color: vars.colors.onPrimaryContainer,
});
